import { AnchorButton } from "../../../../styles";
import { getLinkUrl } from "../../../Helpers";
import { useNavigate } from "react-router-dom";

export const QipCtaBanner = ({ title, copy, cta, bgImage }) => {
  const navigate = useNavigate();
  const newAtts = getLinkUrl((cta && cta.url) || "");

  const renderCTA = () => {
    if (cta && newAtts) {
      return (
        <div className="shrink-0">
          <AnchorButton
            onClick={() =>
              newAtts.external
                ? (window.location = newAtts.href)
                : navigate(newAtts.as)
            }
            color={`white`}
            borderColor={`white`}
            bgColor={`red`}
            hoverColor={`white`}
            hoverBorderColor={`black`}
            hoverBgColor={`black`}
            maxWidth={`none`}
            width={`auto`}
            padding={`1em 1.5em`}
          >
            {cta.title}
          </AnchorButton>
        </div>
      );
    }
  };

  return (
    <div className="relative overflow-hidden">
      {bgImage && (
        <img
          src={bgImage.sizes.hero_banner}
          alt=""
          className="absolute object-cover top-0 left-0 w-full h-full"
        />
      )}
      <div className="relative z-10 py-10 px-4 md:px-0 md:py-20 flex justify-between flex-col md:flex-row gap-10 max-w-[950px] mx-auto items-center">
        <div className="max-w-xl">
          {title && <h3 className="text-white text-4xl mb-4">{title}</h3>}
          {copy && (
            <div
              className="text-white p-0 text-base"
              dangerouslySetInnerHTML={{ __html: copy }}
            />
          )}
        </div>
        {cta && renderCTA()}
      </div>
    </div>
  );
};
